(() => {
  if (window.__WN_STARTER_BUNDLE_FIXES_V5__) return;
  window.__WN_STARTER_BUNDLE_FIXES_V5__ = true;

  const STARTER = 57337524093252;
  const NAMI_PRODUCT = 15580935422276;
  let guardBusy = false;
  let latestCart = null;

  const readCart = () => window.WNCart.refresh({ emit: false, source: 'starter-bundle-read', openDrawer: false });
  const updateCart = (updates) => window.WNCart.update({ updates }, { source: 'starter-bundle-dependency-guard', openDrawer: false, emit: false });
  const starterLines = (cart) => (cart?.items || []).filter((item) => Number(item.variant_id) === STARTER);
  const namiQty = (cart) => (cart?.items || []).reduce((total, item) => total + (Number(item.product_id) === NAMI_PRODUCT ? Number(item.quantity || 0) : 0), 0);

  async function guard(seed = null) {
    if (guardBusy) return seed || latestCart;
    guardBusy = true;
    try {
      let cart = seed && Array.isArray(seed.items) ? seed : await readCart();
      latestCart = cart;
      const lines = starterLines(cart);
      const maxQty = namiQty(cart);
      if (!lines.length) return cart;

      const updates = {};
      if (maxQty < 1) {
        lines.forEach((item) => { updates[item.key] = 0; });
      } else {
        const requested = lines.reduce((total, item) => total + Number(item.quantity || 0), 0);
        const wanted = Math.min(maxQty, Math.max(1, requested));
        if (Number(lines[0].quantity) !== wanted) updates[lines[0].key] = wanted;
        lines.slice(1).forEach((item) => { updates[item.key] = 0; });
      }

      if (Object.keys(updates).length) {
        cart = await updateCart(updates);
        latestCart = cart;
        window.WNCart.publish(cart, { source: 'starter-bundle-dependency-guard', openDrawer: false });
      }
      return cart;
    } catch (error) {
      console.warn('Nami starter bundle guard', error);
      return latestCart;
    } finally {
      guardBusy = false;
    }
  }

  function schedule(seed = null) {
    if (seed?.items) latestCart = seed;
    requestAnimationFrame(() => guard(latestCart).catch(() => {}));
  }

  document.addEventListener('wn:cart:updated', (event) => schedule(event.detail?.cart || null));
  document.addEventListener('wn:cart:view-refreshed', () => schedule());
  document.addEventListener('shopify:section:load', () => schedule());
  window.addEventListener('pageshow', () => schedule());
  document.addEventListener('click', (event) => {
    const link = event.target?.closest?.('[data-wn-starter-bundle-item] a[href], .wn-cart-item--care-starter-actual a[href]');
    if (!link || link.matches('[data-cart-remove]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  window.WNStarterBundle = Object.freeze({
    prepareCheckout: async (seed = null) => {
      const cart = await guard(seed);
      const lines = starterLines(cart);
      const maxQty = namiQty(cart);
      const quantity = lines.reduce((total, item) => total + Number(item.quantity || 0), 0);
      return lines.length > 1 || (lines.length && (maxQty < 1 || quantity > maxQty)) ? null : cart;
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => schedule(), { once: true });
  else schedule();
})();
